import { render, staticRenderFns } from "./PatientCategories.vue?vue&type=template&id=35c58a6a&scoped=true&"
import script from "./PatientCategories.vue?vue&type=script&lang=js&"
export * from "./PatientCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c58a6a",
  null
  
)

export default component.exports